function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVerticalLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 1,
  height: 30
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v200",
  style: {
    stroke: "#fff",
    strokeWidth: 5
  }
}));
export default SvgVerticalLine;